
import { grey } from '@material-ui/core/colors';

export default () => ({
  chipContainer: { marginTop: 10 },
  paper: {
    maxHeight: '300px',
    width: '100%',
    position: 'absolute',
    backgroundColor: 'white',
    zIndex: 2,
    overflow: 'auto',
  },
  inputRoot: { flexWrap: 'wrap' },
  inputInput: {
    width: 'auto',
    flexGrow: 1,
  },
  greyBackground: { backgroundColor: grey[200] },
});
